


import isEmpty from "../../utils/isempty.utils";
import Redirect from "../../components/utils/Redirect";

  
  interface Policy {
    title: string;
    paragraph: string[];
  }

const policy: Policy[] = [
  {
    title: "Introduction",
    paragraph: [
      "Les présentes conditions générales d'utilisation définissent les règles applicables à l'utilisation du site de réservation de tables de notre restaurant.",
      "En accédant et en utilisant notre site, l'utilisateur accepte sans réserve ces conditions générales."
    ]
  },
  {
    title: "Objet du site",
    paragraph: [
      "Le site permet aux utilisateurs de réserver une table en ligne selon les disponibilités et les conditions du restaurant.",
      "L'utilisation du site est gratuite et accessible à toute personne disposant d'une connexion Internet."
    ]
  },
  {
    title: "Responsabilité de l'utilisateur",
    paragraph: [
      "L'utilisateur s'engage à fournir des informations exactes et complètes lors de la réservation.",
      "Il doit respecter les horaires de réservation et informer le restaurant en cas d'annulation ou de modification.",
      "Le restaurant se réserve le droit de restreindre l'accès aux réservations en cas de non-respect répété des engagements."
    ]
  },
  {
    title: "Propriété intellectuelle",
    paragraph: [
      "Tous les contenus présents sur le site (textes, images, logos, design) sont protégés par le droit de la propriété intellectuelle.",
      "Toute reproduction, modification ou diffusion sans autorisation écrite est strictement interdite."
    ]
  },
  {
    title: "Protection des données personnelles (RGPD)",
    paragraph: [
      "Nous collectons et traitons les données personnelles des utilisateurs conformément au Règlement Général sur la Protection des Données (RGPD).",
      "Les informations collectées sont utilisées exclusivement pour la gestion des réservations et l'amélioration des services du restaurant.",
      "L'utilisateur peut exercer ses droits d'accès, de rectification et de suppression en contactant le restaurant."
    ]
  },
  {
    title: "Conservation et utilisation des données",
    paragraph: [
      "Les données de réservation sont conservées de manière sécurisée afin d'optimiser la gestion des tables et améliorer l'expérience utilisateur.",
      "Aucune donnée ne sera vendue à des tiers sans consentement explicite de l'utilisateur."
    ]
  },
  {
    title: "Annulation et modification de réservation",
    paragraph: [
      "L'utilisateur peut annuler ou modifier sa réservation dans un délai raisonnable précisé lors de la réservation.",
      "En cas de retard important ou de non-présentation, le restaurant se réserve le droit d'annuler la réservation et de proposer la table à d'autres clients."
    ]
  },
  {
    title: "Modifications des conditions générales",
    paragraph: [
      "Le restaurant se réserve le droit de modifier ces conditions générales à tout moment.",
      "Les utilisateurs seront informés des changements via le site."
    ]
  },
  {
    title: "Loi applicable et juridiction",
    paragraph: [
      "Les présentes conditions générales sont soumises au droit français.",
      "En cas de litige, les tribunaux compétents seront ceux du ressort du siège social du restaurant."
    ]
  },
  {
    title: "Contact",
    paragraph: [
      "Pour toute question relative aux conditions générales, vous pouvez nous contacter via notre formulaire en ligne ou par email à contact@leblr.fr."
    ]
  }
];





const TermAndPolicy = () => {
  

  return (
    <div className="main-conditions">
      {!isEmpty(policy) &&
      policy.map((value, key) => (
        <div className="term-container" key={key}>
          <div className="title-term">{value.title}</div>
          {value.paragraph.map((valuep, key2) => (
            <div className="subtitle-term" key={key2}>
              {valuep}
            </div>
          ))}
        </div>
      ))}
      {isEmpty(policy) && <Redirect link={"/"} />}
    </div>
  );
};
  
export default TermAndPolicy;
  